import * as organizationSelectors from './organizationSelectors';
import routes from '../helpers/ApplicationRoutes';

export const getCurrentBucketId = state => {
    const { pathname } = state.router.location;
    const params = routes.bucket.getParams(pathname);
    return params ? +params.bucketId : -1;
};

export const getCurrentBucketName = (
    state,
    bucketId = getCurrentBucketId(state),
) => {
    const bucket = state.db.buckets[bucketId];
    if (!bucket) {
        return undefined;
    }
    return bucket.name;
};

export const getBucket = (state, bucketId = getCurrentBucketId(state)) => {
    const bucket = state.db.buckets[bucketId];
    if (!bucket) {
        return undefined;
    }
    
    // Get visible applications excluding hidden ones
    const visibleApps = bucket.visibleInApplications
        .filter(appId => !state.db.applications[appId].hide)
        .map(appId => state.db.applications[appId]);
    
    // Always include the 'all' application if it exists in the state
    if (state.db.applications['all'] && !visibleApps.some(app => app.id === 'all')) {
        visibleApps.unshift(state.db.applications['all']);
    }
    
    return {
        ...bucket,
        visibleInApplications: visibleApps,
    };
};

// filter related
export const getOrganizationBucketsFilterName = state =>
    state.organizationBucketsFilter.bucketName;

// all buckets
export const getBuckets = (
    state,
    organizationId = organizationSelectors.getCurrentOrganizationId(state),
) => {
    const bucketsIds = state.bucketsByOrganization[organizationId];
    if (!bucketsIds) {
        return undefined;
    }

    return bucketsIds.map(bucketId => getBucket(state, bucketId));
};

export const getIsLoadingBuckets = (
    state,
    organizationId = organizationSelectors.getCurrentOrganizationId(state),
) =>
    // return undefined if loading is never started before. Important for
    // authorization hoc
    state.currentOrganizations.loadingBuckets &&
    state.currentOrganizations.loadingBuckets[organizationId];

export const areThereMorePages = (
    state,
    organizationId = organizationSelectors.getCurrentOrganizationId(state),
) => {
    if (
        !state.currentOrganizations.pages ||
        !state.currentOrganizations.pages[organizationId]
    ) {
        return true;
    }

    return state.currentOrganizations.pages[organizationId].more;
};

export const getCurrentPage = (
    state,
    organizationId = organizationSelectors.getCurrentOrganizationId(state),
) => {
    if (
        !state.currentOrganizations.pages ||
        !state.currentOrganizations.pages[organizationId]
    ) {
        return 0;
    }

    return state.currentOrganizations.pages[organizationId].page;
};

export const getAvailableApplicationsForBucket = (
    state,
    bucketId = getCurrentBucketId(state),
) => {
    const bucket = getBucket(state, bucketId);
    const organization = organizationSelectors.getOrganization(
        state,
        bucket.organizationId,
    );
    return organization ? organization.visibleInApplications : [];
};

export const getIsCurrentUserAdminForCurrentBucket = (
    state,
    bucket = getBucket(state),
) => {
    return bucket && bucket.currentUserIsAdmin;
};

export const isAddMember = state =>
    state.searchOrganizationUsersForBucket.isAddMember;



// WEBPACK FOOTER //
// ./src/selectors/bucketSelectors.js